import React from "react";
import styled from "styled-components";

const SliderWraper = styled.div`
  padding: 10px 0;
  display: flex;
  flex-wrap: none;
  overflow-x: auto;
  white-space: nowrap;
`;

function Slider({ children }) {
  const slider = (event) => {
    if (event.deltaY < 0) {
      event.target.closest(".slider").scrollLeft += 30;
    } else if (event.deltaY > 0) {
      event.target.closest(".slider").scrollLeft -= 30;
    }
  };
  return (
    <SliderWraper onWheel={slider} className="slider">
      {children}
    </SliderWraper>
  );
}

export default Slider;
